import React, { useEffect, useState } from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import './sec-event.css'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic34 from '../assets/pic34.png'
import pic28 from '../assets/pic28.png'
import { supabase } from '../supabase';
import './sec-event-content-mangement.css'
import Contentmangementnav from '../component/common/contentnav';
import Input from '../component/common/input';
import './sec-about.css'
import './sec-support.css'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic35 from '../assets/pic35.png'
import pic32 from '../assets/pic32.png'
import Circlecta from '../component/common/circlectsa.jsx';
import AddCTA from '../component/common/addcta.jsx';
import CTA from '../component/common/cta.jsx';



const Navscont = () => {

    
    
    const [navData, setNavData] = useState([]);
  
    const [search, setSearch] = useState('');
    
    const [showForm, setShowForm] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);
    const [filter, setFilter] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    
    const [formData, setFormData] = useState({
    name: '',
    name_ar: '',
    url: '',
      show: true 
    });
    

    
    
    useEffect(() => {
    const fetchData = async () => {
        const { data } = await supabase
        .from('Nav-header')
        .select('*');

        setNavData(data || []);
    };

    fetchData();
    }, []);
    
    
    
const filteredNav = navData.filter((item) => {
  const matchesSearch =
    item.name?.toLowerCase().includes(search.toLowerCase()) ||
    item.name_ar?.toLowerCase().includes(search.toLowerCase()) ||
    item.url?.toLowerCase().includes(search.toLowerCase());

        let matchesFilter = true;

        if (filter === 'shown') {
        matchesFilter = item.show === true;
        }

        if (filter === 'hidden') {
        matchesFilter = item.show === false || item.show === null;
        }

        return matchesSearch && matchesFilter;
        });
            
    
    
    
    
    
    
    
    const createNav = async () => {
    const { error } = await supabase
        .from('Nav-header')
        .insert([
        {
            name: formData.name,
name_ar: formData.name_ar,
            url: formData.url,
              show: formData.show 
        }
        ]);

    if (error) {
        console.log(error);
        return;
    }

    const { data } = await supabase.from('Nav-header').select('*');
    setNavData(data);
    handleClose();
    };
        
    
    
    const handleEditClick = (item) => {
    setFormData({
        name: item.name || '',
         name_ar: item.name_ar || '',
        url: item.url || '',
    show: item.show ?? true
    });

    setEditingId(item.id);
    setIsEditing(true);
    setShowForm(true);
    };
        
    
    
    const updateNav = async () => {
    const { error } = await supabase
        .from('Nav-header')
        .update(formData)
        .eq('id', editingId);

    if (!error) {
        const { data } = await supabase.from('Nav-header').select('*');
        setNavData(data);
        handleClose();
    }
    };
        
    
    
    
    
    
    
    
    const confirmDelete = async () => {
    await supabase.from('Nav-header').delete().eq('id', selectedDeleteId);
    
      setNavData(prev => prev.filter(item => item.id !== selectedDeleteId));

      setShowDeleteModal(false);
      setSelectedDeleteId(null);
    };
    
    
    
    const handleClose = () => {
    setShowForm(false);
    setIsEditing(false);
    setEditingId(null);

    setFormData({
        name: '',
        name_ar: '',
        url: '',
          show: true
    });
    };
    
    return ( 
        
        
<section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Landing Page Content"  
                            para="Manage featured events, FAQs, and testimonials"
                            />
                     
                        
                        </article>




                    {showDeleteModal && (
                    <section className="delete-modal-overlay">
                        <article className="delete-modal" role="dialog" aria-modal="true">
                        
                        <header className="delete-modal-header">
                            <div className="delete-icon-wrapper">
                            <img src={pic35} alt='icon'></img>
                            </div>

                            <div className="delete-text-container">
                            <h2 className="delete-title">Delete section</h2>
                            <p className="delete-description">
                                Are you sure you want to delete this section? This action cannot be undone.
                            </p>
                            </div>
                        </header>

                        <nav className="delete-modal-actions">
                            <button
                            className="delete-btn-cancel"
                            onClick={() => {
                                setShowDeleteModal(false);
                                setSelectedDeleteId(null);
                            }}
                            >
                            Cancel
                            </button>

                            <button
                            className="delete-btn-confirm"
                            onClick={confirmDelete}
                            >
                            Delete
                            </button>
                        </nav>

                        </article>
                    </section>
                    )}




                                        {showForm && (
                                        <div className="overlay-create">
                                            <div className="container-create">

                                            <div className="header-create">
                                                <h1 className="title-create">
                                                {isEditing ? 'Edit About Section' : 'Add About Section'}
                                                </h1>

                                                <button
                                                className="close-btn-create"
                                                onClick={handleClose}
                                                type="button"
                                                >
                                                <img src={pic34} alt='close' />
                                                </button>
                                            </div>

                                         <form
                                                className="form-create"
                                                onSubmit={(e) => {
                                                e.preventDefault();
                                                isEditing ? updateNav() : createNav();
                                                }}>

                                                <Input
                                                title="Name"
                                                placeholder="Enter name"
                                                type="text"
                                                value={formData.name}
                                                onChange={(e) =>
                                                    setFormData({ ...formData, name: e.target.value })
                                                }
                                                />

                                                <Input
                                                title="URL"
                                                placeholder="Enter URL"
                                                type="text"
                                                value={formData.url}
                                                onChange={(e) =>
                                                    setFormData({ ...formData, url: e.target.value })
                                                }
                                                />
                                                <Input
                                                title="Name (Arabic)"
                                                placeholder="Enter Arabic name"
                                                type="text"
                                                value={formData.name_ar}
                                                onChange={(e) =>
                                                    setFormData({ ...formData, name_ar: e.target.value })
                                                }/>



                                                <fieldset className="fieldset">
                                                <label className='title-input'>Show Section</label>

                                                <div className="select-wrapper2">
                                                    <img src={pic28} className="arrow-icon2" alt="arrow" />

                                                    <select
                                                    className="input-search2 select-style2"
                                                    value={formData.show ? "true" : "false"}
                                                    onChange={(e) =>
                                                    setFormData({ ...formData, show: e.target.value === 'true' })
                                                    }
                                                    >
                                                    <option value="true">Show</option>
                                                    <option value="false">Hide</option>
                                                    </select>
                                                </div>
                                                </fieldset>








                                                <nav className='container-ctas-craete'>
                                                <button
                                                    type="button"
                                                    className="cta-cancel-create"
                                                    onClick={handleClose}
                                                >
                                                    <h2 className="cta-cancel-text-create">Cancel</h2>
                                                </button>

                                                <button type="submit" className='cta-create'>
                                                    <h2 className='cta-create-text'>
                                                    {isEditing ? 'Edit Section' : 'Add Section'}
                                                    </h2>
                                                </button>
                                                </nav>

                                            </form>
                                            </div>
                                        </div>
                                        )}




                                           

                        <section className='container-table-and-section'>


                        <Contentmangementnav />



                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper-about">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />

                                <Circlecta  onClick={() => setShowForm(true)}/>

                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>

                                        <option value="shown">Shown</option>
                                        <option value="hidden">Hidden</option>
                                </select>
                                </div>


                            </fieldset>



                                                 <div className="table-container" >

                 


                                 <table className='table-table-concert-mangem'>
                                                                   
{filteredNav.map((item) => (
                                <tbody key={item.id}>
                                    <tr className="row-table2-contenttt">

                                    <div className="container-table-info-about-sec">

                                       
                                        <div className='main-info2'>
                                            <article className='row-aboutt'>
                                                <article className='main-info'>
                                                        <h2 className="header-support">{item.name}</h2>
                                                        <p className="sentfrom-support">{item.url}</p>
                                                </article>
                                                
                                                <nav className='right-box-about'> 
                                                <label className="custom-checkboxl">
                                                    <input
                                                    type="checkbox"
                                                    checked={item.show}
                                                    onChange={async () => {
                                                        const newValue = !item.show;

                                                        await supabase
                                                        .from('Nav-header')
                                                        .update({ show: newValue })
                                                        .eq('id', item.id);

                                                        setNavData(prev =>
                                                        prev.map(el =>
                                                            el.id === item.id ? { ...el, show: newValue } : el
                                                        )
                                                        );
                                                    }}
                                                    />
                                                    <span className="checkmarkcontent"></span>
                                                    <h3 className="SHOW">Show on homepage</h3>
                                                </label>


                                                <nav className='cta-table'>
                                                    <button className='cta2-table'>
                                                        <img src={pic30} alt='hide'></img>
                                                    </button>
                                                    <button
                                                    className='cta2-table'
                                                    onClick={() => handleEditClick(item)}
                                                    >
                                                    <img src={pic31} alt='edit' />
                                                    </button>
                                                    <button
                                                    className='cta2-table'
                                                    onClick={() => {
                                                    setSelectedDeleteId(item.id);
                                                    setShowDeleteModal(true);
                                                            }}
                                                        >
                                                        <img src={pic32} alt='delete' />
                                                        </button>
                                                                                                            
                                                </nav>



                                                </nav>

                                            </article>



                                        <div className='line-supporttt'></div>


                                            <h3 className="header-support-ar">{item.name_ar}</h3>
                                        </div>

                                    </div>


                                    </tr>
                                </tbody>



                         ))}
                           </table>
                                </div>

                                       




                        </section>







                    </section>

            </section>
            </section>
        </section>
     );
}
 
export default Navscont;